// import { FiCheck } from "react-icons/fi";

// const ServiceDescription = () => {
//   return (
//     <div>
//       <img
//         src="/images/property (17).jpg"
//         alt=""
//         className="w-full h-[300px] object-cover"
//       />
//       <p className="mt-2">
//         Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cupiditate,
//         tempora quos cumque accusantium corporis consequuntur soluta facere eius
//         facilis voluptate? Vel natus quod provident culpa dolores quasi modi
//         quidem, quia possimus in accusamus iusto atque esse itaque neque unde
//         aut, assumenda, magnam quas earum fuga. Quibusdam corporis et ullam
//         corrupti?
//       </p>
//       <h1 className="mt-4 text-2xl font-semibold">
//         Making your ideas come to reality with a good home
//       </h1>
//       <p className="mt-2">
//         Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus aut
//         quasi, sit delectus labore, sed repellendus magni rerum beatae deserunt
//         libero. Iusto magnam numquam blanditiis similique assumenda consectetur
//         ducimus voluptates?
//       </p>
//       <div className="flex-col gap-3 mt-3 flex-align-center sm:flex-row">
//         <img
//           src="/images/property (15).jpg"
//           alt=""
//           className="w-full h-[250px] object-cover"
//         />
//         <img
//           src="/images/property (18).jpg"
//           alt=""
//           className="w-full h-[250px] object-cover"
//         />
//       </div>
//       <p className="mt-3">
//         Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nemo nam, quo
//         cumque tempora, vitae aut consequatur ipsam, alias libero quaerat unde
//         tempore sit officiis. Nemo debitis neque alias, harum possimus impedit
//         non itaque culpa recusandae odit cupiditate illo dolores numquam.
//       </p>
//       <div className="mt-3">
//         <div className="flex-align-center gap-x-2">
//           <div className="icon-box text-primary !bg-primary/20">
//             <FiCheck />
//           </div>
//           <p>Outstanding Property</p>
//         </div>
//         <div className="mt-2 flex-align-center gap-x-2">
//           <div className="icon-box text-primary !bg-primary/20">
//             <FiCheck />
//           </div>
//           <p>Professional and experienced human resource</p>
//         </div>
//         <div className="mt-2 flex-align-center gap-x-2">
//           <div className="icon-box text-primary !bg-primary/20">
//             <FiCheck />
//           </div>
//           <p>Provide the best services for users</p>
//         </div>
//         <div className="mt-2 flex-align-center gap-x-2">
//           <div className="icon-box text-primary !bg-primary/20">
//             <FiCheck />
//           </div>
//           <p>Modern city locations and exceptional lifestyle</p>
//         </div>
//         <p className="mt-2">
//           Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus aut
//           quasi, sit delectus labore, sed repellendus magni rerum beatae
//           deserunt libero. Iusto magnam numquam blanditiis similique assumenda
//           consectetur ducimus voluptates?
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ServiceDescription;


import { FiCheck } from "react-icons/fi";

const ServiceDescription = ({ service }) => {
  const serviceData = {
    "Competition Pool": {
      images: ["/images/swimming-pool/competition-pools/1.jpg", "/images/swimming-pool/competition-pools/2.jpg", "/images/swimming-pool/competition-pools/3.jpg"],
      heading: "High-Performance Competition Pools",
      description: [
        "We are proud to present a premium range of competition pool solutions designed for professional athletes and swimming events.",
        "Our pools are engineered to meet international standards, ensuring safety, precision, and performance for every competition.",
      ],
      features: [
        "Precision-engineered pools for competitions",
        "Durable materials for long-term use",
        "Designed for high-performance swimming",
        "Compliance with international standards",
      ],
    },
    "Clubs & Resorts": {
      images: ["/images/swimming-pool/club-resort/1.jpg", "/images/swimming-pool/club-resort/2.jpg", "/images/swimming-pool/club-resort/3.jpg"],
      heading: "Luxury Pools for Clubs and Resorts",
      description: [
        "Transform your club or resort with luxurious swimming pools that blend style and functionality.",
        "We create customized designs that enhance the guest experience while ensuring low maintenance and durability.",
      ],
      features: [
        "Elegant designs for upscale properties",
        "Low-maintenance solutions",
        "Eco-friendly materials and systems",
        "Tailored to your club or resort's unique theme",
      ],
    },
    "Residential Pools": {
      images: ["/images/swimming-pool/residential-pools/1.jpg", "/images/swimming-pool/residential-pools/2.jpg", "/images/swimming-pool/residential-pools/3.jpg"],
      heading: "Custom Residential Pools",
      description: [
        "Enhance your home's aesthetics and functionality with a custom-designed swimming pool.",
        "Our residential pools are tailored to your preferences, ensuring a perfect fit for your lifestyle.",
      ],
      features: [
        "Personalized pool designs",
        "Space-optimized solutions",
        "Energy-efficient pool systems",
        "Integration with modern landscaping",
      ],
    },
    "Water Parks": {
      images: ["/images/swimming-pool/water-park/3.jpg", "/images/swimming-pool/water-park/2.jpg", "/images/swimming-pool/water-park/1.jpeg"],
      heading: "Innovative Water Park Solutions",
      description: [
        "We specialize in creating exciting water park attractions with safety and innovation in mind.",
        "Our designs incorporate thrilling slides, wave pools, and family-friendly features to maximize guest satisfaction.",
      ],
      features: [
        "Creative and fun-filled designs",
        "Safety-first engineering",
        "Durable materials for high-traffic usage",
        "Customizable attractions for all ages",
      ],
    },
  };

  const selectedService = serviceData[service] || serviceData["Competition Pool"];

  return (
    <div>
      <img
        src={selectedService.images[0]}
        alt={service}
        className="w-full h-[300px] rounded-lg object-cover"
      />
      <h1 className="mt-4 text-2xl font-semibold">{selectedService.heading}</h1>
      {selectedService.description.map((desc, index) => (
        <p key={index} className="mt-2">{desc}</p>
      ))}
      <div className="flex-col gap-3 mt-3 flex-align-center sm:flex-row">
        {selectedService.images.slice(1).map((img, index) => (
          <img
            key={index}
            src={img}
            alt={service}
            className="w-full h-[250px] rounded-lg object-cover"
          />
        ))}
      </div>
      <div className="mt-3">
        {selectedService.features.map((feature, index) => (
          <div key={index} className="mt-2 flex-align-center gap-x-2">
            <div className="icon-box text-primary !bg-primary/20">
              <FiCheck />
            </div>
            <p>{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
};


export default ServiceDescription;
